'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoadingDots = require('components/LoadingDots/LoadingDots');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = exports.Loader = function (_Component) {
  (0, _inherits3.default)(Loader, _Component);

  function Loader() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, Loader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = Loader.__proto__ || (0, _getPrototypeOf2.default)(Loader)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = { visible: false }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(Loader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this = this;

      this.timer = setTimeout(function () {
        return _this.setState({ visible: true });
      }, this.props.afterMs);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      // We only want to show loading dots when really slow internet
      // connection, otherwise just show an empty section item
      return _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
          'li',
          { className: 'dropdown__item dropdown__item--loader' },
          this.state.visible && _react2.default.createElement(_LoadingDots.LoadingDots, null)
        )
      );
    }
  }]);
  return Loader;
}(_react.Component);

Loader.defaultProps = {
  afterMs: 1500
};

Loader.propTypes = {
  afterMs: _propTypes2.default.number
};